import {MenuItem} from '@/store/types';
import {RouteConfig} from 'vue-router';

export function routes (): RouteConfig[] {
    return [
        {
            name: 'media.library',
            path: '/multimedia/libreria',
            component: () => import('@/modules/media/components/MediaLibrary.vue'),
            children: [
                {
                    name: 'media.library.viewer',
                    path: 'archivo/:id',
                    component: () => import('@/modules/media/components/MediaViewerDialog.vue'),
                    meta: {
                        authRequired: true,
                        toolbarTitle: 'Ver archivo',
                        vuex: {
                            loadModules: ['media'],
                        },
                    },
                },
            ],
            meta: {
                authRequired: true,
                toolbarTitle: 'Librería Multimedia',
                module: 'media.library',
                vuex: {
                    loadModules: ['media'],
                },
            },
        },
    ]
}

export function menu (): MenuItem[] {
    return [
        {
            title: 'Librería multimedia',
            icon: 'mdi-folder-multiple-image',
            routeName: 'media.library',
            requireAuthorization: true,
            permission: '@/media/admin',
        },
    ]
}
